/*
Door Closers

  --closer <boolean::switch> | ['Top', 'Bottom']
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Closers'
const id = 'bPqdQX4VztjF33RjPpTY'

export default {
  name,
  id,
  filters,
  headers,
  form
}
